import { useModal } from "@components-common/modals";
import { FormProvider } from "../../../components-common/forms/provider";
import { FormBase, InputFileUpload } from "@components-common/forms";
import { QueryClient, QueryClientProvider } from "react-query";

const ReSubmissionModalContent = (props: any) => {
  const queryClient = new QueryClient();
  const formProps: any = {
    element: { fileName: "", contents: "" },
    schema: {},
    onSubmit: (val: any) => console.log(val),
  };

  return (
    <QueryClientProvider client={queryClient}>
      <FormProvider>
        <FormBase {...formProps}>
          <InputFileUpload />
        </FormBase>
      </FormProvider>
    </QueryClientProvider>
  );
};

export const ReSubmissionCell = (
  col: any,
  row: any,
  index: any,
  extraData: any
) => {
  const { showModal } = useModal();
  const props: any = {
    Component: ReSubmissionModalContent,
    title: "Re-submission",
    show: true,
    onClose: () => {},
    onHide: () => {},
    actions: [],
    props: {
      id: 1,
    },
  };
  return (
    <button
      onClick={() => showModal(props)}
      className={"test-column-description"}
    >
      open
    </button>
  );
};

export const colAssignmentReSubmission = {
  dataField: 'id',
  formatter: ReSubmissionCell,
  sort: false,
  text: "Re-submission",
};
